import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {GetSidebar, GetSidebarModel} from 'domain/usecases';

export class RemoteGetSidebar implements GetSidebar {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetSidebarModel>,
	) {}

	async get(): Promise<GetSidebarModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
